/**
 * Category / level badges on course cards only carry information when they
 * differ between courses. On a single-subject tenant (e.g. Revise: 24 courses,
 * all "History CAPS", all "Grade 12") the same badge on every card is pure
 * noise, so the grids suppress a badge whose value is uniform across the
 * course list they render from.
 *
 * Computed by the page (which holds the full list) and passed down as props —
 * the card itself only ever sees one course.
 */
export interface UniformBadgeFlags {
  hideCategory: boolean;
  hideLevel: boolean;
}

export function uniformBadgeFlags(
  courses: Array<{ category?: string | null; level?: string | null }>,
): UniformBadgeFlags {
  // With zero or one course there is nothing to be uniform against — keep the
  // badges, they may still orient a first visitor.
  if (courses.length <= 1) return { hideCategory: false, hideLevel: false };
  const categories = new Set(courses.map((c) => c.category ?? ''));
  const levels = new Set(courses.map((c) => c.level ?? ''));
  return {
    hideCategory: categories.size === 1,
    hideLevel: levels.size === 1,
  };
}
